import { STATUSES, makePaginationState, concatUnique } from 'app/utils/redux';

import * as storyDetailT from 'app/redux/front/storyDetail/types';

import * as t from './types';

const initialState = {
  watchLaterStories: makePaginationState(),
};

export default (state = initialState, action) => {
  switch (action.type) {
    case `${t.FETCH_WATCH_LATER_STORIES}_PENDING`:
      return {
        ...state,
        watchLaterStories: {
          ...state.watchLaterStories,
          status: STATUSES.PENDING,
        },
      };
    case `${t.FETCH_WATCH_LATER_STORIES}_SUCCESS`:
      return {
        ...state,
        watchLaterStories: {
          status: STATUSES.SUCCESS,
          isLoaded: true,
          pagination: {
            ...action.payload.result,
            items: concatUnique(
              state.watchLaterStories.pagination.items,
              action.payload.result.items
            ),
          },
        },
      };
    case `${t.FETCH_WATCH_LATER_STORIES}_ERROR`:
      return {
        ...state,
        watchLaterStories: {
          ...state.watchLaterStories,
          status: STATUSES.ERROR,
        },
      };

    case `${t.DELETE_WATCH_LATER_STORY}_SUCCESS`:
    case `${storyDetailT.DELETE_WATCH_LATER_STORY}_SUCCESS`:
      return {
        ...state,
        watchLaterStories: {
          ...state.watchLaterStories,
          pagination: {
            ...state.watchLaterStories.pagination,
            items: state.watchLaterStories.pagination.items.filter(
              (item) => item.id !== action.meta.storyId
            ),
          },
        },
      };

    case `${storyDetailT.SAVE_WATCH_LATER_STORY}_SUCCESS`:
      return {
        ...state,
        watchLaterStories: {
          ...state.watchLaterStories,
          pagination: {
            ...state.watchLaterStories.pagination,
            items: [action.payload.result].concat(
              state.watchLaterStories.pagination.items
            ),
          },
        },
      };

    default:
      return { ...state };
  }
};



// WEBPACK FOOTER //
// ./src/app/redux/front/watchLaterList/reducer.js